import { Toast } from "vant";

// 时间转换: 2019-10-10
export function Todate(num) { //Tue Apr 02 2019 11:36:27 GMT+0800 (中国标准时间)
    // console.log(num)
    num = num + "";
    var date = "";
    var str = [];
    var month = new Array();
    month["Jan"] = 1; month["Feb"] = 2; month["Mar"] = 3; month["Apr"] = 4; month["May"] = 5; month["Jun"] = 6;
    month["Jul"] = 7; month["Aug"] = 8; month["Sep"] = 9; month["Oct"] = 10; month["Nov"] = 11; month["Dec"] = 12;
    var week = new Array();
    week["Mon"] = "一"; week["Tue"] = "二"; week["Wed"] = "三"; week["Thu"] = "四"; week["Fri"] = "五"; week["Sat"] = "六"; week["Sun"] = "日";
    str = num.split(" ");
    date = str[3] + "-";
    // console.log(date)
    date = date + month[str[1]] + "-" + str[2];
    return date;
}
// 计算生日时间
export function compareTime(time1, time2) { //time1: 选择日期, time2: 当前日期
    // console.log(time1, time2)
    var year1 = time1.split('-')[0], // 选择
        month1 = time1.split('-')[1],
        day1 = time1.split('-')[2];
    var year2 = time2.split('-')[0], // 当前
        month2 = time2.split('-')[1],
        day2 = time2.split('-')[2];
    if (time1 > time2) {
        Toast('选择时间不能超过当前时间');
        return ''
    } else {
        if (month2 > month1) {
            console.log('111', year2 - year1)
            return year2 - year1   // 当前日期
        } else if (month2 == month1) {
            if (day2 >= day1) {
                console.log('222', year2 - year1)
                return year2 - year1
            } else {
                console.log('333', year2 - year1)
                return year2 - year1
            }
        } else {
            console.log('444', year2 - year1 - 1)
            return year2 - year1 - 1
        }
    }
    /*if(
        (time1 == time2) // 年月日相等
        || 
        (year1 == year2 && month1 < month2) // 年相等,选择的月小于当前月
        || 
        (year1 == year2 && month1 == month2 && day1 <= day2) // 1选择 2 当前
        // (month1 > month2) {year2-year1}else if(month1 == month2){
        // (day1 > day2){year2-year1}
        // }
    ){
        console.log(111)
        return 1;
    } else if(
        (year1 < year2 && month1 == month2 && day1 == day2) 
        || 
        (year1 < year2 && month1 > month2) 
        || 
        (year1 < year2 && month1 == month2 && day1 > day2)
    ){
        console.log(222)
        return year2-year1;
    } else if(
        (year1 < year2 && month1 == month2 && day1 < day2) 
        || 
        (year1 < year2 && month1 == month2 && day1 <= day2) 
        || 
        (year1 < year2 && month1 < month2 && day1 == day2)
    ){
        console.log(333)
        return year2-year1+1;
    } else{
        Toast('选择时间不能超过当前时间');
        return ''
    }*/
    // if(time1 == time2){
    //     // console.log('相等');
    //     return 0;
    // } else if(time1.split('-')[0] == time2.split('-')[0] && time1.split('-')[1] < time2.split('-')[1] ){
    //     // console.log(1)
    //     return 1;
    // } else if((time1.split('-')[0] <= time2.split('-')[0]) && (time1.split('-')[1] <= time2.split('-')[1]) && (time1.split('-')[2] <= time2.split('-')[2])){
    //     // console.log(time2.split('-')[0] - time1.split('-')[0]);
    //     return time2.split('-')[0] - time1.split('-')[0] + 1
    // }else if((time1.split('-')[0] <= time2.split('-')[0]) && (time1.split('-')[1] <= time2.split('-')[1]) && (time1.split('-')[2] >= time2.split('-')[2])){
    //     // console.log(time2.split('-')[0] - time1.split('-')[0] + 1)
    //     return (time2.split('-')[0] - time1.split('-')[0] + 1)
    // } else if((time1.split('-')[0] <= time2.split('-')[0]) && (time1.split('-')[1] >= time2.split('-')[1]) && (time1.split('-')[2] <= time2.split('-')[2])){
    //     // console.log((time2.split('-')[0] - time1.split('-')[0]));
    //     return (time2.split('-')[0] - time1.split('-')[0] + 1)
    // } else if(time1 > time2){
    //     // console.log('xiaoyu');
    //     Toast('选择时间不能超过当前时间');
    //     return ''
    // }
}

// 计算工作年限
export function computeWorkYear(time1, time2) {
    // console.log(time1, time2,'按时大大说的')
    // time1 = '2016-06-12';
    // time2 = '2016-09-13';
    var year1 = Number(time1.split('-')[0]), // 选择
        month1 = Number(time1.split('-')[1]),
        day1 = Number(time1.split('-')[2]);
    var year2 = Number(time2.split('-')[0]), // 当前
        month2 = Number(time2.split('-')[1]),
        day2 = Number(time2.split('-')[2]);
    var nowDate = Date.parse(new Date());
    var date = new Date(time1.replace(/-/g, '/'));
    if (date > nowDate) {
        Toast('选择时间不能超过当前时间');
        return ''
    } else {
        // console.log('month2',month2,'month1',month1)
        if (month2 > month1) {
            // console.log('month2 > month1',month2 > month1,month2 , month1)
            // console.log('111555', year2 - year1, month2 - month1)
            return year2 - year1 == 0 ? ( month2 - month1 ) + '个月' : ( year2 - year1 ) + '年' + ( month2 - month1 ) + '个月';
            // return year2 - year1   // 当前日期
        } else if (month2 == month1) {
            // console.log('month2 == month1',month2 == month1)
            if (day2 >= day1) {
                // console.log('day2 >= day1',day2 >= day1)
                // console.log('222555', year2 - year1)
                return (year2 - year1) + '年'
                // return year2 - year1
            } else {
                // console.log('day2 < day1',day2 < day1)
                // console.log('333555', year2 - year1);
                return (year2 - year1) + '年'
                // return year2 - year1
            }
        } else if (month2 < month1) {
            // console.log('month2 < month1',month2 < month1)
            // console.log('444555', year2 - year1 - 1, month2 - month1 + 12);
            // if(year2 - year1 - 1 == 0){
            //     return ( month2 - month1 +) + '个月'
            // } else if(year2 - year1 - 1 > 0){
            //     return ( year2 - year1 - 1 ) + '年' + ( month2 - month1 + 12 ) + '个月';
            // }
            return (year2 - year1 - 1 == 0) ? ( month2 - month1 + 12 ) + '个月' : ( year2 - year1 - 1 ) + '年' + ( month2 - month1 + 12 ) + '个月';
            // return year2 - year1
        }
    }
}

// 时间戳转年限(年龄)
export function TimeToYear(time) {
    var nowDate = new Date();
    // console.log('nowDate',nowDate);
    var _nowDate = Todate(nowDate);
    // console.log('_nowDate',_nowDate)
    var date = new Date(time).toDateString();
    // console.log('date',date)
    var _date = Todate(date);
    // console.log('_date',_date);
    // console.log(_date, _nowDate);
    var num = compareTime(_date, _nowDate);
    // console.log('nianling ',num)
    return num;
}
// 时间戳转年限(工作年限)
export function TimeToWorkYear(time) {
    var nowDate = new Date();
    // console.log('nowDate',nowDate);
    var _nowDate = Todate(nowDate);
    // console.log('_nowDate',_nowDate)
    var date = new Date(time).toDateString();
    // console.log('date',date)
    var _date = Todate(date);
    // console.log('_date',_date);
    // console.log(_date, _nowDate);
    var num = computeWorkYear(_date, _nowDate);
    // console.log('nianling ',num)
    return num;
}
// 格式化时间
function add0(num) {
    return num < 10 ? '0' + num : num;
}
// 时间转换: 2019.10.10
export function toDateString(date) {
    var time = new Date(date);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    return y + '.' + add0(m) + '.' + add0(d);
}

// 判断设备是手机端还是pc端
export function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}


// WEBPACK FOOTER //
// ./src/utils/index.js